import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.object.assign.js';
import { __awaiter } from '../../../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Stack, AssistChip } from '@hub-la/design-system';
import '@mui/icons-material/ThumbUp';
import '@mui/icons-material/ThumbUpOutlined';
import Reply from '@mui/icons-material/Reply';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePostComment } from '../../hooks/use-post-comment.js';
import { useDiscussion } from '../../providers/discussion.js';
import { InputComment } from '../input-comment/input-comment.js';

const CommentActions = ({
  likes,
  onLike,
  isLiked,
  isReply,
  parentCommentId,
  onReplySuccess,
  parentUserId,
  parentUserName
}) => {
  const [replying, setReplying] = useState(false);
  const {
    t
  } = useTranslation();
  const {
    currentUser
  } = useDiscussion();
  const {
    mutateAsync,
    isLoading
  } = usePostComment({
    onSuccess: () => {
      if (isReply || !onReplySuccess) return;
      onReplySuccess();
    }
  });
  const handleReply = () => __awaiter(void 0, void 0, void 0, function* () {
    setReplying(true);
  });
  const commentButtonLabel = replying ? t('replyInputComment.submit') : t('inputComment.submit');
  return jsxs(Stack, Object.assign({
    width: "100%"
  }, {
    children: [jsxs(Stack, Object.assign({
      direction: "row",
      gap: 2,
      mb: 2
    }, {
      children: [false , !replying && jsx(AssistChip, {
        variant: "text",
        size: "small",
        icon: jsx(Reply, {}),
        label: t('comment.actions.reply'),
        onClick: handleReply
      })]
    })), (isLoading || replying) && jsx(InputComment, {
      avatarSize: 24,
      onCancel: () => setReplying(false),
      onComment: (message, hasMention) => __awaiter(void 0, void 0, void 0, function* () {
        setReplying(false);
        yield mutateAsync({
          message,
          parentCommentId,
          mentionUserId: hasMention ? parentUserId : undefined
        });
      }),
      isLoading: isLoading,
      avatarUrl: currentUser === null || currentUser === void 0 ? void 0 : currentUser.picture,
      commentButtonLabel: commentButtonLabel,
      isReply: replying,
      inputLabel: t('replyInputComment.label'),
      metionUserId: parentUserId,
      metionUserName: parentUserName
    })]
  }));
};

export { CommentActions };
